// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Roles Management Page Styles */

.roles-page {
  max-width: 1400px;
  margin: 0 auto;
  padding: 20px;
}

.roles-header {
  margin-bottom: 30px;
}

.roles-header h1 {
  margin: 0 0 8px;
  color: #333;
  font-size: 28px;
}

.roles-header p {
  margin: 0;
  color: #666;
}

/* Role Cards */
.role-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
  margin-bottom: 30px;
}

.role-card {
  background: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;
  border: 2px solid transparent;
}

.role-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
}

.role-card.selected {
  transform: translateY(-4px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);
}

.role-header {
  padding: 15px 20px;
  color: white;
}

.role-header h3 {
  margin: 0;
  font-size: 18px;
}

.role-body {
  padding: 20px;
}

.role-description {
  margin: 0 0 15px;
  color: #666;
  font-size: 14px;
}

.role-count {
  display: flex;
  align-items: baseline;
  gap: 5px;
  margin-bottom: 15px;
}

.role-count .count {
  font-size: 28px;
  font-weight: 700;
  color: #333;
}

.role-count .label {
  font-size: 14px;
  color: #999;
}

.role-permissions {
  margin: 0;
  padding: 0;
  list-style: none;
}

.role-permissions li {
  padding: 5px 0;
  font-size: 13px;
  color: #666;
  border-bottom: 1px solid #f0f0f0;
}

.role-permissions li:last-child {
  border-bottom: none;
}

.role-permissions li.more {
  color: #667eea;
  font-weight: 500;
}

/* Bulk Actions */
.bulk-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
  background: white;
  border-radius: 12px;
  margin-bottom: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.selection-info {
  display: flex;
  align-items: center;
  gap: 15px;
}

.selection-info span {
  font-size: 14px;
  color: #666;
}

.btn-clear {
  padding: 6px 12px;
  background: none;
  border: none;
  color: #667eea;
  font-size: 13px;
  cursor: pointer;
}

.btn-clear:hover {
  text-decoration: underline;
}

.bulk-controls {
  display: flex;
  gap: 10px;
}

.bulk-controls select {
  padding: 8px 15px;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 14px;
}

.bulk-controls .btn-primary {
  padding: 8px 20px;
}

/* Users Section */
.users-section {
  background: white;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.users-section h2 {
  margin: 0 0 20px;
  color: #333;
  font-size: 20px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.filter-badge {
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 12px;
  color: white;
}

/* Table */
.table-container {
  overflow-x: auto;
}

.data-table {
  width: 100%;
  border-collapse: collapse;
}

.data-table th,
.data-table td {
  padding: 12px 15px;
  text-align: left;
  border-bottom: 1px solid #eee;
}

.data-table th {
  font-weight: 600;
  color: #666;
  font-size: 12px;
  text-transform: uppercase;
  background: #f9f9f9;
}

.data-table tr:hover {
  background: #f9f9f9;
}

.data-table tr.selected {
  background: #f0f4ff;
}

.checkbox-col {
  width: 40px;
}

.checkbox-col input {
  width: 16px;
  height: 16px;
  cursor: pointer;
}

/* User Cell */
.user-cell {
  display: flex;
  align-items: center;
  gap: 10px;
}

.user-avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 14px;
}

.user-info {
  display: flex;
  flex-direction: column;
}

.user-name {
  font-weight: 500;
  color: #333;
}

.you-badge {
  font-size: 11px;
  color: #667eea;
  font-weight: 500;
}

/* Role Select */
.role-select {
  padding: 6px 10px;
  border: 2px solid;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  background: white;
}

/* Action Buttons */
.action-buttons {
  display: flex;
  gap: 5px;
}

.btn-icon {
  width: 28px;
  height: 28px;
  border: 2px solid;
  border-radius: 50%;
  background: transparent;
  cursor: pointer;
  font-size: 12px;
  font-weight: 600;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
}

.btn-icon:hover {
  transform: scale(1.1);
}

.btn-icon.active-role {
  box-shadow: 0 0 0 2px white, 0 0 0 4px currentColor;
}

/* Status Badges */
.status-badge {
  display: inline-block;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
}

.status-badge.active {
  background: #d4edda;
  color: #155724;
}

.status-badge.inactive {
  background: #f8d7da;
  color: #721c24;
}

/* No Data */
.no-data {
  text-align: center;
  padding: 40px;
  color: #999;
  font-size: 16px;
}

/* Modal */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background: white;
  border-radius: 12px;
  width: 90%;
  max-width: 600px;
  max-height: 90vh;
  overflow-y: auto;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid #eee;
}

.modal-header h2 {
  margin: 0;
  font-size: 20px;
  color: #333;
}

.modal-close {
  background: none;
  border: none;
  font-size: 28px;
  color: #999;
  cursor: pointer;
  padding: 0;
  line-height: 1;
}

.modal-body {
  padding: 20px;
}

.role-detail {
  margin-bottom: 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid #eee;
}

.role-detail:last-child {
  margin-bottom: 0;
  padding-bottom: 0;
  border-bottom: none;
}

.role-detail h3 {
  margin: 0 0 10px;
  font-size: 18px;
}

.role-detail p {
  margin: 0 0 10px;
  color: #666;
}

.role-detail ul {
  margin: 0;
  padding-left: 20px;
}

.role-detail li {
  padding: 4px 0;
  font-size: 14px;
  color: #666;
}

/* Buttons */
.btn-primary {
  padding: 10px 20px;
  background: #667eea;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s;
}

.btn-primary:hover {
  background: #5568d3;
}

.btn-primary:disabled {
  background: #ccc;
  cursor: not-allowed;
}

/* Error Message */
.error-message {
  background: #fee;
  border: 1px solid #fcc;
  color: #c33;
  padding: 12px;
  border-radius: 8px;
  margin-bottom: 20px;
}

/* Loading */
.admin-loading {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  font-size: 18px;
  color: #666;
}

/* Responsive */
@media (max-width: 768px) {
  .bulk-actions {
    flex-direction: column;
    gap: 15px;
    align-items: stretch;
  }

  .selection-info {
    flex-direction: column;
    align-items: flex-start;
  }

  .bulk-controls {
    flex-direction: column;
  }

  .role-cards {
    grid-template-columns: 1fr;
  }

  .action-buttons {
    flex-wrap: wrap;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/admin/RolesManagement.css"],"names":[],"mappings":"AAAA,iCAAiC;;AAEjC;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,WAAW;AACb;;AAEA,eAAe;AACf;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,wCAAwC;EACxC,eAAe;EACf,2CAA2C;EAC3C,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,WAAW;EACX,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,kBAAkB;AAClB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,YAAY;AACd;;AAEA,UAAU;AACV;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mDAAmD;AACrD;;AAEA,kBAAkB;AAClB;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,YAAY;AACZ;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,eAAe;AACjB;;AAEA,UAAU;AACV;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,WAAW;EACX,eAAe;EACf,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,WAAW;AACb;;AAEA,YAAY;AACZ;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,gBAAgB;EAChB,sBAAsB;EACtB,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA,eAAe;AACf;EACE;IACE,sBAAsB;IACtB,SAAS;IACT,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* Roles Management Page Styles */\r\n\r\n.roles-page {\r\n  max-width: 1400px;\r\n  margin: 0 auto;\r\n  padding: 20px;\r\n}\r\n\r\n.roles-header {\r\n  margin-bottom: 30px;\r\n}\r\n\r\n.roles-header h1 {\r\n  margin: 0 0 8px;\r\n  color: #333;\r\n  font-size: 28px;\r\n}\r\n\r\n.roles-header p {\r\n  margin: 0;\r\n  color: #666;\r\n}\r\n\r\n/* Role Cards */\r\n.role-cards {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\r\n  gap: 20px;\r\n  margin-bottom: 30px;\r\n}\r\n\r\n.role-card {\r\n  background: white;\r\n  border-radius: 12px;\r\n  overflow: hidden;\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\r\n  cursor: pointer;\r\n  transition: transform 0.2s, box-shadow 0.2s;\r\n  border: 2px solid transparent;\r\n}\r\n\r\n.role-card:hover {\r\n  transform: translateY(-4px);\r\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);\r\n}\r\n\r\n.role-card.selected {\r\n  transform: translateY(-4px);\r\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n.role-header {\r\n  padding: 15px 20px;\r\n  color: white;\r\n}\r\n\r\n.role-header h3 {\r\n  margin: 0;\r\n  font-size: 18px;\r\n}\r\n\r\n.role-body {\r\n  padding: 20px;\r\n}\r\n\r\n.role-description {\r\n  margin: 0 0 15px;\r\n  color: #666;\r\n  font-size: 14px;\r\n}\r\n\r\n.role-count {\r\n  display: flex;\r\n  align-items: baseline;\r\n  gap: 5px;\r\n  margin-bottom: 15px;\r\n}\r\n\r\n.role-count .count {\r\n  font-size: 28px;\r\n  font-weight: 700;\r\n  color: #333;\r\n}\r\n\r\n.role-count .label {\r\n  font-size: 14px;\r\n  color: #999;\r\n}\r\n\r\n.role-permissions {\r\n  margin: 0;\r\n  padding: 0;\r\n  list-style: none;\r\n}\r\n\r\n.role-permissions li {\r\n  padding: 5px 0;\r\n  font-size: 13px;\r\n  color: #666;\r\n  border-bottom: 1px solid #f0f0f0;\r\n}\r\n\r\n.role-permissions li:last-child {\r\n  border-bottom: none;\r\n}\r\n\r\n.role-permissions li.more {\r\n  color: #667eea;\r\n  font-weight: 500;\r\n}\r\n\r\n/* Bulk Actions */\r\n.bulk-actions {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 15px 20px;\r\n  background: white;\r\n  border-radius: 12px;\r\n  margin-bottom: 20px;\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.selection-info {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 15px;\r\n}\r\n\r\n.selection-info span {\r\n  font-size: 14px;\r\n  color: #666;\r\n}\r\n\r\n.btn-clear {\r\n  padding: 6px 12px;\r\n  background: none;\r\n  border: none;\r\n  color: #667eea;\r\n  font-size: 13px;\r\n  cursor: pointer;\r\n}\r\n\r\n.btn-clear:hover {\r\n  text-decoration: underline;\r\n}\r\n\r\n.bulk-controls {\r\n  display: flex;\r\n  gap: 10px;\r\n}\r\n\r\n.bulk-controls select {\r\n  padding: 8px 15px;\r\n  border: 1px solid #ddd;\r\n  border-radius: 8px;\r\n  font-size: 14px;\r\n}\r\n\r\n.bulk-controls .btn-primary {\r\n  padding: 8px 20px;\r\n}\r\n\r\n/* Users Section */\r\n.users-section {\r\n  background: white;\r\n  border-radius: 12px;\r\n  padding: 24px;\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.users-section h2 {\r\n  margin: 0 0 20px;\r\n  color: #333;\r\n  font-size: 20px;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n}\r\n\r\n.filter-badge {\r\n  padding: 4px 12px;\r\n  border-radius: 12px;\r\n  font-size: 12px;\r\n  color: white;\r\n}\r\n\r\n/* Table */\r\n.table-container {\r\n  overflow-x: auto;\r\n}\r\n\r\n.data-table {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n}\r\n\r\n.data-table th,\r\n.data-table td {\r\n  padding: 12px 15px;\r\n  text-align: left;\r\n  border-bottom: 1px solid #eee;\r\n}\r\n\r\n.data-table th {\r\n  font-weight: 600;\r\n  color: #666;\r\n  font-size: 12px;\r\n  text-transform: uppercase;\r\n  background: #f9f9f9;\r\n}\r\n\r\n.data-table tr:hover {\r\n  background: #f9f9f9;\r\n}\r\n\r\n.data-table tr.selected {\r\n  background: #f0f4ff;\r\n}\r\n\r\n.checkbox-col {\r\n  width: 40px;\r\n}\r\n\r\n.checkbox-col input {\r\n  width: 16px;\r\n  height: 16px;\r\n  cursor: pointer;\r\n}\r\n\r\n/* User Cell */\r\n.user-cell {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n}\r\n\r\n.user-avatar {\r\n  width: 36px;\r\n  height: 36px;\r\n  border-radius: 50%;\r\n  color: white;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-weight: 600;\r\n  font-size: 14px;\r\n}\r\n\r\n.user-info {\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.user-name {\r\n  font-weight: 500;\r\n  color: #333;\r\n}\r\n\r\n.you-badge {\r\n  font-size: 11px;\r\n  color: #667eea;\r\n  font-weight: 500;\r\n}\r\n\r\n/* Role Select */\r\n.role-select {\r\n  padding: 6px 10px;\r\n  border: 2px solid;\r\n  border-radius: 4px;\r\n  font-size: 12px;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n  background: white;\r\n}\r\n\r\n/* Action Buttons */\r\n.action-buttons {\r\n  display: flex;\r\n  gap: 5px;\r\n}\r\n\r\n.btn-icon {\r\n  width: 28px;\r\n  height: 28px;\r\n  border: 2px solid;\r\n  border-radius: 50%;\r\n  background: transparent;\r\n  cursor: pointer;\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  transition: all 0.2s;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.btn-icon:hover {\r\n  transform: scale(1.1);\r\n}\r\n\r\n.btn-icon.active-role {\r\n  box-shadow: 0 0 0 2px white, 0 0 0 4px currentColor;\r\n}\r\n\r\n/* Status Badges */\r\n.status-badge {\r\n  display: inline-block;\r\n  padding: 4px 10px;\r\n  border-radius: 12px;\r\n  font-size: 12px;\r\n  font-weight: 500;\r\n}\r\n\r\n.status-badge.active {\r\n  background: #d4edda;\r\n  color: #155724;\r\n}\r\n\r\n.status-badge.inactive {\r\n  background: #f8d7da;\r\n  color: #721c24;\r\n}\r\n\r\n/* No Data */\r\n.no-data {\r\n  text-align: center;\r\n  padding: 40px;\r\n  color: #999;\r\n  font-size: 16px;\r\n}\r\n\r\n/* Modal */\r\n.modal-overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background: rgba(0, 0, 0, 0.5);\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  z-index: 1000;\r\n}\r\n\r\n.modal-content {\r\n  background: white;\r\n  border-radius: 12px;\r\n  width: 90%;\r\n  max-width: 600px;\r\n  max-height: 90vh;\r\n  overflow-y: auto;\r\n}\r\n\r\n.modal-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 20px;\r\n  border-bottom: 1px solid #eee;\r\n}\r\n\r\n.modal-header h2 {\r\n  margin: 0;\r\n  font-size: 20px;\r\n  color: #333;\r\n}\r\n\r\n.modal-close {\r\n  background: none;\r\n  border: none;\r\n  font-size: 28px;\r\n  color: #999;\r\n  cursor: pointer;\r\n  padding: 0;\r\n  line-height: 1;\r\n}\r\n\r\n.modal-body {\r\n  padding: 20px;\r\n}\r\n\r\n.role-detail {\r\n  margin-bottom: 20px;\r\n  padding-bottom: 20px;\r\n  border-bottom: 1px solid #eee;\r\n}\r\n\r\n.role-detail:last-child {\r\n  margin-bottom: 0;\r\n  padding-bottom: 0;\r\n  border-bottom: none;\r\n}\r\n\r\n.role-detail h3 {\r\n  margin: 0 0 10px;\r\n  font-size: 18px;\r\n}\r\n\r\n.role-detail p {\r\n  margin: 0 0 10px;\r\n  color: #666;\r\n}\r\n\r\n.role-detail ul {\r\n  margin: 0;\r\n  padding-left: 20px;\r\n}\r\n\r\n.role-detail li {\r\n  padding: 4px 0;\r\n  font-size: 14px;\r\n  color: #666;\r\n}\r\n\r\n/* Buttons */\r\n.btn-primary {\r\n  padding: 10px 20px;\r\n  background: #667eea;\r\n  color: white;\r\n  border: none;\r\n  border-radius: 8px;\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n  transition: background 0.2s;\r\n}\r\n\r\n.btn-primary:hover {\r\n  background: #5568d3;\r\n}\r\n\r\n.btn-primary:disabled {\r\n  background: #ccc;\r\n  cursor: not-allowed;\r\n}\r\n\r\n/* Error Message */\r\n.error-message {\r\n  background: #fee;\r\n  border: 1px solid #fcc;\r\n  color: #c33;\r\n  padding: 12px;\r\n  border-radius: 8px;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n/* Loading */\r\n.admin-loading {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  height: 100vh;\r\n  font-size: 18px;\r\n  color: #666;\r\n}\r\n\r\n/* Responsive */\r\n@media (max-width: 768px) {\r\n  .bulk-actions {\r\n    flex-direction: column;\r\n    gap: 15px;\r\n    align-items: stretch;\r\n  }\r\n\r\n  .selection-info {\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n  }\r\n\r\n  .bulk-controls {\r\n    flex-direction: column;\r\n  }\r\n\r\n  .role-cards {\r\n    grid-template-columns: 1fr;\r\n  }\r\n\r\n  .action-buttons {\r\n    flex-wrap: wrap;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
